/*
 * TODO: check api responses proptypes
 */
import { MESSAGE_TYPES, NOTIFICATION_TYPES } from './chat';

export const QUESTION_TYPES = {
  general: 'true-false',
  multiSelect: 'multi-select',
  singleSelect: 'single-select',
  numeric: 'numeric',
  scale: 'scale',
  text: 'text',
  comment: 'comment',
  consent: 'consent',
  appointmentConsent: 'appointment_consent',
};

export const WIDE_TYPES = [
  QUESTION_TYPES.scale,
  QUESTION_TYPES.multiSelect,
  QUESTION_TYPES.singleSelect,
];

export const COMMUNITY_TYPES = {
  public: 'public',
  private: 'private',
  global: 'global',
};

export const STATUS_FILTER_TYPES = {
  all: 'all',
  joined: 'joined',
  notJoined: 'not_joined',
};

export const PROGRAM_VALUE_TYPES = {
  all: null,
  none: 'none',
};

export const SORT_TYPES = {
  asc: 'asc',
  desc: 'desc',
};

export const FILTER_BY = {
  ACTIVE: 'active',
  HISTORY: 'history',
};

export const PROPS_LIST = {
  appAlert: {
    type: ['success', 'error', 'danger'],
  },
  btn: {
    color: ['accent', 'danger', 'primary'],
    kind: ['flat', 'raised', 'link', 'icon', 'text'],
  },
  circle: {
    type: ['family', 'provider', 'invite', 'team'],
  },
  drawer: {
    position: ['left', 'right'],
  },
  imgPreview: {
    size: ['small', 'regular'],
  },
  msg: {
    type: [
      MESSAGE_TYPES.ATTACHMENT,
      MESSAGE_TYPES.TEXT,
      MESSAGE_TYPES.NOTIFICATION,
      MESSAGE_TYPES.REMINDER,
      MESSAGE_TYPES.LINK_PREVIEW,
      MESSAGE_TYPES.UPLOAD_ATTACHMENT,
    ],
    notification: [
      NOTIFICATION_TYPES.PARTICIPANT_ADDED,
      NOTIFICATION_TYPES.PROVIDER_ASSIGNED,
      NOTIFICATION_TYPES.SYSTEM,
      NOTIFICATION_TYPES.HEALTH_ALERT,
      NOTIFICATION_TYPES.UPCOMING_SURVEY,
      NOTIFICATION_TYPES.ANSWERED_SURVEY,
      NOTIFICATION_TYPES.AUTO_RESPONSE,
      NOTIFICATION_TYPES.ASSIGN_TO_PROGRAM,
      NOTIFICATION_TYPES.REMOVE_FROM_PROGRAM,
      NOTIFICATION_TYPES.FAMILY_MEMBER,
      NOTIFICATION_TYPES.PROVIDER_REMOVED,
    ],
  },
  previewableBlock: {
    toggler: {
      align: ['left', 'right', 'center', 'stretch'],
    },
  },
  survey: {
    questionType: [
      QUESTION_TYPES.general,
      QUESTION_TYPES.multiSelect,
      QUESTION_TYPES.singleSelect,
      QUESTION_TYPES.numeric,
      QUESTION_TYPES.scale,
      QUESTION_TYPES.text,
    ],
    frequency: ['once', 'daily', 'weekly', 'monthly', 'annually'],
    type: ['general', 'program'],
  },
  textInput: {
    color: ['default', 'primary', 'transparent'],
  },
  community: {
    type: [
      COMMUNITY_TYPES.public,
      COMMUNITY_TYPES.private,
      COMMUNITY_TYPES.global,
    ],
  },
  statusFilter: {
    options: [
      STATUS_FILTER_TYPES.all,
      STATUS_FILTER_TYPES.joined,
      STATUS_FILTER_TYPES.notJoined,
    ],
  },
};

export const INVITATION_TYPES = {
  FAMILY_MEMBER: 'family_member_invitation',
  COMMUNITY_MEMBER: 'community_member_invitation',
  PATIENT: 'patient_invitation',
  PROVIDER: 'provider_invitation',
};

export const USER_TYPES = {
  FAMILY_MEMBER: 'family-member',
  PATIENT: 'patient',
  PROVIDER: 'provider',
};

export const USER_TYPES_PROPS = [
  USER_TYPES.FAMILY_MEMBER,
  USER_TYPES.PATIENT,
  USER_TYPES.PROVIDER,
];

export const USER_TYPE_PATIENT = 'patient';
export const USER_TYPE_PROVIDER = 'provider';
export const USER_TYPE_CAREGIVER = 'caregiver';
export const USER_TYPE_FAMILY_MEMBER = 'familyMember';

export const USER_STATUS_INVITED = 'invited';
export const USER_STATUS_CREATED = 'created';
export const USER_STATUS_JOINED = 'joined';

export const USER_STATUS_TYPES = [
  USER_STATUS_INVITED,
  USER_STATUS_CREATED,
  USER_STATUS_JOINED,
];

export const UNREAD_COUNT_SORTING = 'unreadCount';
export const LAST_MESSAGE_SORTING = 'lastMessageAt';

export const UI_POPUP_TYPES = {
  REPORT: 'report',
  MESSAGE: 'message',
  DASHBOARD_CHANGE_STATUS: 'dashboard_change_status',
  PAYA_PAYMENT: 'paya_payment',
  LOADER: 'loader',
  MOBILE_APP: 'mobile_app',
  MFA_NOTICE: 'mfa_notice',
  PAYA_ACCOUNT_FORM: 'paya_account_form',
  PAYA_PAYMENT_HANDLE_RESPONSE: 'paya_payment_handle-response',
  MEDICATIONS_REFILLS: 'medications_refills',
};

export const REPORT_RESOURCES = {
  COMMENT: 'comment',
  POST: 'post',
  COMMUNITY: 'community',
};

export const REPORT_ENDPOINT_BY_RESOURCE_TYPE = {
  [REPORT_RESOURCES.COMMENT]: 'comments',
  [REPORT_RESOURCES.POST]: 'posts',
  [REPORT_RESOURCES.COMMUNITY]: 'communities',
};

export const COMPLAINT_RESOLVE_ACTIONS = {
  SEND_MESSAGE: 'send_chat_message',
  REMOVE_AUTHOR: 'remove_author_from_community',
  DESTROY_REPORTABLE: 'destroy_reportable',
};

export const COMPLAINT_RESOLVED_TITLES = {
  [COMPLAINT_RESOLVE_ACTIONS.SEND_MESSAGE]: 'reports.history.messageSent',
  [COMPLAINT_RESOLVE_ACTIONS.REMOVE_AUTHOR]:
    'reports.history.originatorRemoved',
  [COMPLAINT_RESOLVE_ACTIONS.DESTROY_REPORTABLE]: 'reports.history.wasDeleted',
};

// don't add another roles here
export const CARE_ROLE = {
  PARENT: 'parent',
  FAMILY_MEMBER: 'family_member',
  CAREGIVER: 'caregiver',
  GUARDIAN: 'guardian',
  PROXY: 'proxy',
};

export const PATIENT = 'patient';

export const SEARCH_TABS = {
  PEOPLE: 'people',
  TEAMS: 'teams',
  PROVIDERS: 'providers',
};

export const PAYMENT_STATUS = {
  paid: 'paid',
  unpaid: 'unpaid',
};

export const DASHBOARD_TIME_VALIDATION_RULES = {
  format: 'HH:mm ZZ',
};

export const DEPENDENT_STATUSES = {
  UNVERIFIED: 'unverified',
  PENDING: 'pending',
};

export const ASSIGMENT_STATUS = {
  PERMANENT: 'permanent',
  TEMPORARY: 'temporary',
};

export const ADD_PATIENT_STEPS = {
  CONTACTS: 'contacts',
  PERSONAL_INFO: 'personalInfo',
  ADDRESS: 'address',
};



// WEBPACK FOOTER //
// ./src/constants/props.js